import React, { useState, useEffect } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { useDispatch, useSelector } from 'react-redux'
import { VNDialog } from '../../VNCustomerFacingDisplay/components/VNDialog'
import { getCustomerPayingWithCard } from '../Selectors'
import { centsToDollars } from '../../utils/formatters'
import { setCustomerPayingWithCard } from '../ActionCreators'
import { resetCFD } from '../../VNCustomerFacingDisplay/ActionCreators'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import { clearCart } from '../../actions/cart'
import { clearPromotionsOnOrder } from '../../actions/promotion'
import useRemoteOrderTotal from '../../hooks/useRemoteOrderTotal'
import { sendCFDScreenNav } from '../../VNAndroidSDK/bridgeCalls/VNWebSDKDataSend'
import { CFD_SCREEN } from '../../VNCustomerFacingDisplay/Enums'
import { clearOrderInProgress } from '../../actions/order'

const useStyles = makeStyles(theme => ({
  
}))

export const VNCustomerPayingWithCard = () => {
  const dispatch = useDispatch()
  const history = useHistory()
  const [loadRemoteOrderTotal, {}, resetOrderTotals] = useRemoteOrderTotal()

  const dialogOptions = useSelector(state => getCustomerPayingWithCard(state))

  const [inputStart, setInputStart] = useState(new Date())

  const modalCloseTime = 3 // long press for 3 seconds before closing the modal

  const setTimeStart = () => {
    setInputStart(new Date())
  }

  const setTimeExit = () => {
    if ((new Date().getTime() - inputStart.getTime()) / 1000 < modalCloseTime) {
      return
    }
    // clear cart
    dispatch(clearCart())

    // clear promotions on order
    dispatch(clearPromotionsOnOrder())

    dispatch(clearOrderInProgress())

    // reset order totals
    resetOrderTotals()
    
    // navigate CFD back to IDLE
    sendCFDScreenNav(CFD_SCREEN.IDLE)

    // navigate POS back to 
    history.push('/concession-order')

    // reset the state locally
    dispatch(resetCFD(true))

    dispatch(setCustomerPayingWithCard({open: false}))
  }

  return (
    <div onTouchStart={setTimeStart} onMouseDown={setTimeStart} onTouchEnd={setTimeExit} onMouseUp={setTimeExit} onMouseLeave={setTimeExit}>
      <VNDialog  open={dialogOptions?.get('open')}
                        subTitle={"Customer Paying {{AMOUNT}} with Card".replace('{{AMOUNT}}', centsToDollars(dialogOptions?.get('amount')))}/>
    </div>
  )
}
